<div class="generic-confirm-modal">
  <div class="generic-confirm-modal__header">
    <h3 class="modal-title">All Password Attempts Used</h3>
  </div>
  <div class="generic-confirm-modal__body">
    <div>
      You've used all your password attempts. To reset your password, please contact IdenTrust at
      <b>{{ idenTrustSupportPhone }}</b
      >.<br />
      <br />You'll need to cancel the closing.
    </div>
    <div class="generic-confirm-modal__footer">
      <app-button-container>
        <app-button
          type="primary"
          (buttonClick)="cancelSigning()"
          [dataTestId]="'expired-cert-password-cancel-signing'"
        >
          Cancel Closing
        </app-button>
      </app-button-container>
    </div>
  </div>
</div>
